import 'css-chunksrc/client/common/textInput/styles.scss';export default {
  "textInput": "_textInput_i6kqy_1",
  "multilineTextInput": "_multilineTextInput_i6kqy_22",
  "invalidTextInput": "_invalidTextInput_i6kqy_37",
  "invalidMultilineTextInput": "_invalidMultilineTextInput_i6kqy_41"
};